import { useGetAllSubscriptionsQuery } from "@/services/api/entities/payment";

export const useHistoryContent = () => {
  const { data, isLoading } = useGetAllSubscriptionsQuery();

  return {
    data,
    isLoading,
  };
};
